var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: _vm.size, withBgClickEvent: true },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "ModalContent",
              {
                staticClass: "relative",
                attrs: { actionClasses: "!pt-0" },
                scopedSlots: _vm._u([
                  {
                    key: "actions",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "w-full flex justify-end gap-4",
                            attrs: { id: "decline-buttons" },
                          },
                          [
                            _vm.actions.noBtn
                              ? _c("UiButton", {
                                  attrs: {
                                    disabled: false,
                                    variant: "outline",
                                    buttonText: _vm.noBtnText,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeModal(false)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm.actions.okBtn
                              ? _c("UiButton", {
                                  attrs: {
                                    variant: "black",
                                    buttonText: _vm.okBtnText,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeModal(true)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("div", { class: { "flex space-x-2": _vm.hasIcon } }, [
                  _vm.hasIcon
                    ? _c(
                        "span",
                        { staticClass: "text-black mt-1" },
                        [_c("ScheduleInfoIcon", { staticClass: "w-4" })],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "h-full m-0" }, [
                    _c("p", { staticClass: "font-bold text-base" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                    _c(
                      "p",
                      { staticClass: "mt-1", class: _vm.descriptionClasses },
                      [_vm._v(" " + _vm._s(_vm.text) + " ")]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }